import { combineReducers } from "redux";
import alert from './alert';
import auth from './auth';
import bar from './bar';
import booking from './booking';
import conference from './conference';
import coupon from './coupon';
import feedback from './feedback';
import gallery from './gallery';
import guest from './guest';
import payment from './payment';
import room from './room';

export default combineReducers({
    alert,
    auth,
    room,
    guest,
    booking,
    coupon,
    payment,
    gallery,
    feedback,
    bar,
    conference
});